import { render, staticRenderFns } from "./knowledgeDetails.vue?vue&type=template&id=d4144640&"
import script from "./knowledgeDetails.vue?vue&type=script&lang=ts&"
export * from "./knowledgeDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports